import { escapeRegexpString } from '@direct-frontend/stdlib';
import { MaskitoPlugin, MaskitoPostprocessor, MaskitoPreprocessor } from '@maskito/core';
import { maskitoCaretGuard } from '@maskito/kit';

type MaskAdditionals = {
    preprocessor?: MaskitoPreprocessor;
    postprocessor?: MaskitoPostprocessor;
    plugin?: MaskitoPlugin;
};
export const createMaskPostfixAdditionals = (postfix: string): MaskAdditionals => {
    // Своя реализация добавления постфикса, из-за бага с обработкой маски с постфиксом ' $'
    // И бага с постфиксом ' руб.'
    return {
        preprocessor: ({ elementState, data }) => {
            const { value, ...others } = elementState;

            // Убирает postfix в конце строки
            const newValue = value.replace(new RegExp(escapeRegexpString(postfix) + '$'), '');

            return { elementState: { value: newValue, ...others }, data };
        },
        postprocessor: elementState => {
            // В случае пустого значения постфикс не добавляем
            if (!elementState.value) {
                return elementState;
            }

            // Возвращаем постфикс обратно
            return {
                value: elementState.value + postfix,
                selection: elementState.selection,
            };
        },
        plugin: maskitoCaretGuard(
            (value, [selectionStart, selectionEnd]) =>
                // Проверка на то что мы не выделяем символы
                selectionStart === selectionEnd
                    ? [0, value.length - postfix.length] // Позволяем двигать курсором до начала постфикса
                    : [selectionStart, selectionEnd], // Позволяем выделять любую часть строки,
        ),
    };
};
